class VanillaPageReload {
  constructor() {
    this.lastWidth = window.innerWidth;
    this.lastDPR = window.devicePixelRatio || 1;

    this.timer = null;
    this.DEBOUNCE_MS = 300;
    this.WIDTH_THRESHOLD = 10;

    this._bindEvents();
  }

  _shouldReload() {
    const w = window.innerWidth;
    const dpr = window.devicePixelRatio || 1;

    const widthChanged = Math.abs(w - this.lastWidth) > this.WIDTH_THRESHOLD;
    const dprChanged = dpr !== this.lastDPR;

    return widthChanged || dprChanged;
  }

  _handleChange() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      if (this._shouldReload()) {
        // 無限リロード防止のため、直前の値を更新してからリロード
        this.lastWidth = window.innerWidth;
        this.lastDPR = window.devicePixelRatio || 1;
        location.reload();
      }
    }, this.DEBOUNCE_MS);
  }

  _bindEvents() {
    window.addEventListener("resize", () => this._handleChange(), {
      passive: true,
    });

    window.addEventListener(
      "orientationchange",
      () => setTimeout(() => this._handleChange(), 200),
      { passive: true }
    );

    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) this._handleChange();
    });
  }
}

export default VanillaPageReload;
